<template>
    <div class="marker-container" @click="onClick">
        <svg viewBox="0 0 36 36">
            <circle class="marker-circle" cx="18" cy="18" r="6" :fill="color" />
        </svg>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import { getPartnerCustomizationWithDefault } from "@/views/shared/partners";

export default Vue.extend({
    name: "OfflineMarker",
    props: {
        color: {
            type: String,
            default: getPartnerCustomizationWithDefault().latestPrimaryNoDataColor,
        },
        id: {
            type: Number,
        },
    },
    methods: {
        onClick() {
            this.$emit("marker-click", { id: this.id });
        },
    },
});
</script>

<style lang="scss" scoped>
.marker-circle {
    stroke: white;
    stroke-opacity: 0.5;
    stroke-width: 2;
}
.marker-container {
    width: 24px;
    height: 24px;
    cursor: pointer;
    text-align: center;
    top: -12px;
}
</style>
